module.exports = __webpack_public_path__ + "static/media/payment.6022d3f0.png";